module.exports = __webpack_public_path__ + "static/img/course7.339a90e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course7.png
// module id = 71g7
// module chunks = 63